<!-- <AppLink :secondary="true">Ссылка</AppLink> -->

<template>
  <router-link v-if="to"
    :to="to"
    class="link"
    :class="classes">
    <slot />
    <app-svg v-if="hasArrow"
      id="arrow-right" />
  </router-link>

  <a v-else
    :href="href"
    target="_blank"
    class="link"
    :class="classes">
    <slot />
    <app-svg v-if="hasArrow"
      id="arrow-right" />
  </a>
</template>

<script>
import { computed, reactive } from "vue";

export default {
  name: "AppLink",
  props: {
    to: {
      type: [String, Object],
      default: null,
    },
    href: {
      type: String,
      default: null,
    },
    secondary: {
      type: Boolean,
      default: false,
    },
    hasArrow: {
      type: Boolean,
      default: true
    },
    asButton: {
      type: Boolean,
      default: false
    }
  },

  setup(props) {
    props = reactive(props);

    return {
      classes: computed(() => ({
        _secondary: props.secondary,
        '_as-button': props.asButton
      })),
    };
  },
};
</script>

<style lang="scss" scoped>
.link {
  $that: &;

  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 8px 14px 8px 0;
  font-size: 10px;
  line-height: 12px;
  font-weight: 400;
  text-transform: uppercase;
  text-decoration: none;
  border: none;
  color: $color_primary;
  background-color: transparent;
  cursor: pointer;
  -webkit-appearance: none;
  -moz-appearance: none;

  @include hover {
    svg {
      transform: translateX(14px);
    }
  }

  &:active {
    svg {
      transform: translateX(14px);
    }
  }

  &._secondary {
    color: rgba($color: $color_dark-90, $alpha: 0.5);
  }

  &._as-button {
    background: $color_orange-50;
    height: 46px;
    font-size: 14px;
    text-transform: uppercase;
    color: $white;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    white-space: nowrap;
    padding: 0 48px;
    border-radius: 23px;
  }

  svg {
    width: 6px;
    height: 12px;
    margin-left: 16px;
    transition: transform 0.3s ease;
  }
}
</style>
